'use strict';

import * as domUtils from '../util/dom';
import ErrorType from '../constants/error-type';
var device = require('../util/device');
var extend = require('../util/extend');
var statsUtil = require('../util/stats');
import * as url from '../util/url';
var SVPCustomEvent = require('../util/custom-event');
var Sizzle = require('sizzle');
import { createEventWrapper } from '../util/event-wrapper-api';
var VideoUtil = require('../util/video-attributes');

var Debug = require('../util/debug')('flash-video');

var CLASSNAMES = {
    flashPosterImage: 'svp_js-flash-poster-image'
};

module.exports = (function () {

    // Structure is {objectNode: <DOMObject>, initialized: <Boolean>}
    var instances = {};

    function _attachEventListeners() {
        if (window.__svtplayerCallback__ === undefined) {
            window.__svtplayerCallback__ = function (UID, eventName, data) {
                if (eventName !== 'timeupdate') {
                    Debug('flash event (' + UID + '): ' + eventName + (!!data ? ' with data ' + data : ''));
                }

                var instance = instances[UID],
                    objectNode;
                if (instance) {
                    objectNode = instance.objectNode;

                    //Map our custom flash events to standard html5 events
                    switch (eventName) {
                        case 'initialized':
                            instance.initialized = true;
                            objectNode.dispatchEvent(new SVPCustomEvent(eventName, {detail: data}));
                            objectNode.dispatchEvent(new SVPCustomEvent('play')); //Kind of hacky, but needed for the splash to disappear at the right time
                            break;
                        case 'paused':
                            objectNode.dispatchEvent(new SVPCustomEvent('pause'));
                            break;
                        default:
                            objectNode.dispatchEvent(new SVPCustomEvent(eventName, {detail: data}));
                            break;
                    }
                }
            };
        }
    }

    function _internalLoad(videoElement, UID) {
        var instance = instances[UID];
        if (instance) {
            if (instance.initialized) {
                instance.objectNode.dispatchEvent(new SVPCustomEvent('play'));

                return;
            }

            var parentNode = videoElement.parentNode,
                imgPath = videoElement.poster || 'https://www.svtplay.se/public/images/default/play_default_998x561.jpg',
                existingObjectNode = Sizzle('object', parentNode)[0],
                imgNode = Sizzle('.svp_image', parentNode)[0];

            if (existingObjectNode) {
                parentNode.replaceChild(instance.objectNode, existingObjectNode);
            } else {
                parentNode.insertBefore(instance.objectNode, videoElement);
                domUtils.hide(videoElement);
            }

            if (!imgNode) {
                parentNode.insertBefore(domUtils.fromString('<img class="svp_image ' + CLASSNAMES.flashPosterImage + '" src=' + imgPath + '>'), instance.objectNode);
            } else {
                imgNode.setAttribute('src', imgPath);
            }

            var interval = setInterval(function () {
                var item = Sizzle('.svp_js-flash-error', parentNode)[0];

                if (!item) {
                    clearInterval(interval);
                    parentNode.off('flash.initialized');
                } else if (item.offsetParent !== null) {
                    clearInterval(interval);
                    parentNode.off('flash.initialized');
                    parentNode.fire('error', {
                        name: ErrorType.FLASH_NOT_SUPPORTED
                    });
                }
            }, 100);

            parentNode.on('flash.initialized', function () {
                clearInterval(interval);
                parentNode.off('flash.initialized');
            });

            _attachEventListeners();
        }
    }

    return {
        load: function (videoElement, videoUrl, captionUrl, metadata) {
            var swfPath = url.absolutePath('svtplayer-2017.03.swf'),
                client = statsUtil.getClient(),
                programTitle = (metadata.mmsStatistics && metadata.mmsStatistics.ns_st_pr) || 'unknown_program',
                episodeTitle = (metadata.mmsStatistics && metadata.mmsStatistics.ns_st_ep) || 'unknown_episode',
                categoryTitle = (metadata.mmsStatistics && metadata.mmsStatistics.ns_st_pl) || 'unknown_category';

            const uid = VideoUtil.getUID(videoElement) || VideoUtil.generateAndSetUID(videoElement);

            var settings = {
                video: {
                    videoReferences: [{'url': videoUrl, playerType: 'flash' }],
                    subtitleReferences: [{'url': captionUrl }],
                    position : VideoUtil.getStartPosition(videoElement)
                },
                statistics: {
                    client: client,
                    mmsClientNr: statsUtil.getMmsClientNr(),
                    programId: metadata.programVersionId,
                    statisticsUrl: statsUtil.getComscoreBaseUrl() + client + '.' + programTitle + '.' + episodeTitle,
                    title: episodeTitle,
                    folderStructure: programTitle,
                    category: categoryTitle
                },
                context: {
                    UID: uid
                }
            };

            if (metadata.live) {
                settings.video.live = true;
                if (metadata.timeshiftEnabled) {
                    settings.video.dvr = true;
                    settings.materialLength = metadata.contentDuration;
                    settings.video.livestartUTC = metadata.liveStartTimeUTC;
                }
            }

            if (metadata.simulcast) {
                settings.video.live = true;
                settings.video.dvr = false;
                settings.disabled = 'live';
            }

            if (!VideoUtil.isControlsEnabled(videoElement)) {
                settings.disabled = 'controlbar';
            }

            var instance = instances[uid],
                parentNode = videoElement.parentNode,
                readyFn,
                objectNode;

            if (!(instance && instance.initialized)) {
                if (device.isIE() || !device.supportsFlash) {
                    objectNode = domUtils.fromString(
                        '<object id="' + uid + '" class="svp_video svp_flashvideo" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"> \
							<param name="movie" value="' + swfPath + '" /> \
							<param name="flashvars" value="json=' + encodeURIComponent(JSON.stringify(settings)) + '" /> \
							<param name="allowscriptaccess" value="always" /> \
							<param name="allowfullscreen" value="true" /> \
							<param name="bgcolor" value="#000000" /> \
							<param name="wmode" value="direct" /> \
							<div class="svp_js-flash-error"></div>\
						</object>');
                } else {
                    objectNode = domUtils.fromString(
                        '<object id="' + uid + '" class="svp_video svp_flashvideo" type="application/x-shockwave-flash" \
							data="' + swfPath + '"> \
							<param name="flashvars" value="json=' + encodeURIComponent(JSON.stringify(settings)) + '" /> \
							<param name="allowscriptaccess" value="always" /> \
							<param name="allowfullscreen" value="true" /> \
							<param name="bgcolor" value="#000000" /> \
							<param name="wmode" value="direct" /> \
							<div class="svp_js-flash-error"></div>\
						</object>');
                }

                const origSeek = objectNode.seek;
                const flashSetVolume = objectNode.setVolume;
                const flashGetVolume = objectNode.getVolume;
                const extension = {
                        customEvents: ['initialized'],
                        getDuration: function () {
                            return metadata.contentDuration;
                        },
                        getCurrentTime: function () {
                            return this.getPosition ? this.getPosition(true) : 0;
                        },
                        getVolume: function () {
                            if (flashGetVolume) {
                                return flashGetVolume();
                            }

                            return null;
                        },
                        play: _internalLoad.bind(this, videoElement, uid),
                        pause: function () {
                            if (this.svtPause) {
                                this.svtPause();
                            }
                        },
                        getTextTracks: function () {
                            return [];
                        },
                        seek: function (position) {
                            if (origSeek) {
                                origSeek(position, true, false);
                            }
                        },
                        setVolume: function (volume) {
                            if (flashSetVolume) {
                                flashSetVolume(volume, false);
                            }
                        },
                        reset: function () {
                            try {
                                if (this.seek) {
                                    this.seek(0);
                                }
                            } catch (err) { }

                        },
                        getMetrics: function () {
                            return {
                                flash: true,
                                dash: false,
                                droppedFrames: -1,
                                dimensions: -1,
                                resolution: -1,
                                bufferLevel: -1
                            };
                        },
                        unload: function () {
                            var uid = this.getAttribute('id'),
                                instance = instances[uid];

                            if (instance) {
                                var posterImage = Sizzle('.' + CLASSNAMES.flashPosterImage, this.parentElement)[0];

                                if (posterImage) {
                                    this.parentElement.removeChild(posterImage);
                                }
                                this.parentElement.removeEventListener('ready', readyFn);
                                this.parentElement.removeChild(this);
                                domUtils.show(videoElement);
                                delete instances[uid];
                            }

                        }
                    };

                extend(objectNode, createEventWrapper());
                extend(objectNode, extension);
                instances[uid] = {objectNode: objectNode, initialized: false};
            } else {
                const retryFn = () => {
                    Debug.error('Error re-using Flash-object, retrying.');
                    objectNode.unload();
                    objectNode = this.load.apply(this, arguments); // eslint-disable-line prefer-rest-params
                };

                objectNode = instance.objectNode;
                if (objectNode && objectNode.setJSONItem) {
                    var jsonString = JSON.stringify(settings),
                        flashvars = 'json=' + encodeURIComponent(jsonString);

                    Sizzle('param[name="flashvars"]', objectNode)[0].setAttribute('value', flashvars);
                    try {
                        // If the Flash-object is in a bad state, this will fail -- hence try/catch
                        objectNode.setJSONItem(jsonString);
                    } catch (e) {
                        retryFn();
                    }
                } else {
                    //if objectNode don't have flash registered functions we re-initalized it
                    retryFn();
                }
            }

            readyFn = function () {
                parentNode.removeEventListener('ready', readyFn);

                // Let the world know we're ready to play
                objectNode.dispatchEvent(new SVPCustomEvent('loadstart'));
                objectNode.dispatchEvent(new SVPCustomEvent('loadedmetadata'));
                objectNode.dispatchEvent(new SVPCustomEvent('canplay'));
            };
            parentNode.addEventListener('ready', readyFn);

            return objectNode;
        }

    };
})();



// WEBPACK FOOTER //
// ./src/js/modules/flash-video.js